import useCommentDialog from 'components/CommentDialog/useCommentDialog';
import useDialog from 'components/ConfirmDialog/useDialog';
import { useSelector, useDispatch } from 'react-redux';
import {
    APPLICANT,
    CCO,
    CLUSTER_ADMIN,
    REQUEST_FOR_RETURN,
    RETURNED,
    RE_SUBMITTED,
    SECRETARY,
    SUBMITTED,
    IRB,
    CONFIRMED,
} from 'utility/lookup';
import {
    // CONFIRM_REQUEST_TO_RETURN_CONFIRM,
    // RETURN_APPLICATION_SUCCESS,
    REQUEST_FOR_RETURN_TIPS,
    REQUEST_FOR_RETURN_SUCCESS,
} from 'utility/frontendMessage';
import { setGlobal, setGlobalLoading } from 'store/global/reducer';
import { UPDATE_APPLICATION_STATUS_WITH_DETAIL } from 'store/key';
import { getTimeWithTimeZone } from 'utility/general';
import { useHistory } from 'react-router-dom';
import api from 'api/call';

const usePostApprovalTableAction = ({ row, fetchPostApproval = () => null }) => {
    const userRole = useSelector((state) => state.user.role);
    const userDetail = useSelector((state) => state.user.detail);
    const showCommentDialog = useCommentDialog();
    const history = useHistory();
    const dispatch = useDispatch();
    const showDialog = useDialog();

    const { statusId, id, docType: documentType, expiryDtm } = row;

    const updateStatus = ({ status, comment, docId, docType }) => {
        return api.postApprovalActivities.updateStatusCommon({
            docType,
            docId,
            updateStatus: status,
            comment,
        });
    };

    // console.log('154616 usePostApprovalTableAction.js row', row);

    const checkHasApplicantPermission = (data) => {
        const CIList = data?.ciAndCid;
        const PIList = data?.piAndPid;
        const currentUserEmail = userDetail.email.toLowerCase();

        // if ciAndCid === null, the document should belongs to site info document
        const isStudyInfo = CIList !== null;

        let isExist = false;
        if (isStudyInfo) {
            CIList?.forEach((item) => {
                if (item.toLowerCase() === currentUserEmail) {
                    isExist = true;
                }
            });
        } else {
            PIList?.forEach((item) => {
                if (item.toLowerCase() === currentUserEmail) {
                    isExist = true;
                }
            });
        }

        return isExist;
    };

    const actions = [
        {
            text: 'Request for Return',
            showInStatus: [SUBMITTED, RE_SUBMITTED],
            condition: () => {
                // need to check if ci has permission

                // console.log(
                //     '094808 usePostApprovalTableAction.js checkHasApplicantPermission()',
                //     checkHasApplicantPermission(),
                // );

                return checkHasApplicantPermission(row);
                // return true;
            },
            action: async () => {
                const { submit, comment } = await showCommentDialog({
                    title: REQUEST_FOR_RETURN_TIPS,
                    placeholder: 'Please state the reason(s).',
                });

                const type = documentType;

                if (!type) {
                    return;
                }

                if (submit) {
                    // case of post-approval document
                    if (type !== 1) {
                        setGlobalLoading(true);
                        updateStatus({ status: REQUEST_FOR_RETURN, comment, docId: id, docType: type })
                            .then((res) => {
                                fetchPostApproval('updateDtm');
                                showDialog({
                                    description: REQUEST_FOR_RETURN_SUCCESS,
                                    disableCancelButton: true,
                                });
                            })
                            .finally(() => {
                                setGlobalLoading(false);
                            });
                    } else {
                        // case of amendment form
                        setGlobalLoading(true);
                        dispatch({
                            type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                            payload: {
                                id,
                                updateApplicationList: true,
                                status: REQUEST_FOR_RETURN,
                                details: [
                                    {
                                        comment,
                                        type: 2,
                                        value: id,
                                    },
                                ],
                                callback: async () => {
                                    fetchPostApproval('updateDtm');
                                    await showDialog({
                                        description: REQUEST_FOR_RETURN_SUCCESS,
                                        disableCancelButton: true,
                                    });
                                },
                                final: () => {
                                    setGlobalLoading(false);
                                },
                            },
                        });
                    }
                }
            },
            showActionInRoles: [APPLICANT],
            disableConfirm: true,
        },
        // {
        //     text: 'Confirm Request for Return',
        //     showInStatus: [REQUEST_FOR_RETURN],
        //     action: async () => {
        //         const { submit, comment, expiryDtm } = await showCommentDialog({
        //             title: CONFIRM_REQUEST_TO_RETURN_CONFIRM,
        //             placeholder: 'Leave comment if any',
        //             isRequired: true,
        //             showExpiryDate: true,
        //         });

        //         if (!submit) {
        //             return;
        //         }

        //         setGlobalLoading(true);

        //         dispatch({
        //             type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
        //             payload: {
        //                 id: id,
        //                 status: RETURNED,
        //                 currentStatus: statusId,
        //                 expiryDate: expiryDtm,
        //                 details: [
        //                     {
        //                         comment,
        //                         type: 2,
        //                         value: id,
        //                     },
        //                 ],
        //                 callback: () => {
        //                     fetchPostApproval('updateDtm');
        //                     showDialog({
        //                         description: RETURN_APPLICATION_SUCCESS,
        //                         disableCancelButton: true,
        //                     });
        //                 },
        //                 final: () => {
        //                     setGlobalLoading(false);
        //                 },
        //             },
        //         });
        //     },
        //     showActionInRoles: [CCO, SECRETARY],
        //     disableConfirm: true,
        // },
        // {
        //     text: 'Confirm Review Result',
        //     action: () => {
        //         history.push(`/post-approval-document/confirm-review-result?appId=${id}&documentType=${documentType}`);
        //         dispatch({
        //             type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
        //             payload: {
        //                 id: id,
        //                 status: RETURNED,
        //                 currentStatus: statusId,
        //                 // expiryDate,
        //                 details: [
        //                     {
        //                         // comment,
        //                         type: 2,
        //                         value: id,
        //                     },
        //                 ],
        //                 callback: () => {
        //                     fetchPostApproval('updateDtm');
        //                     showDialog({
        //                         description: CONFIRM_REQUEST_FOR_RETURN_SUCCESS,
        //                         disableCancelButton: true,
        //                     });
        //                 },
        //                 final: () => {
        //                     setGlobalLoading(false);
        //                 },
        //             },
        //         });
        //     },
        //     showActionInRoles: [REVIEWER],
        //     showInStatus: [FOR_REVIEW],
        //     disableConfirm: true,
        // },
        {
            text: 'Change of expiry date',
            showInStatus: [RETURNED],
            action: () => {
                dispatch(
                    setGlobal({
                        isExtensionFormOpen: true,
                        appId: id,
                        originalExpiryDate: expiryDtm ? getTimeWithTimeZone(expiryDtm).format('YYYY-MM-DD') : '-',
                        callback: () => fetchPostApproval('updateDtm'),
                        documentType,
                    }),
                );
            },
            showActionInRoles: [CCO, SECRETARY, CLUSTER_ADMIN],
        },
        {
            text: 'Arrange Meeting',
            action: () => {
                history.push('/review/arrange-meeting');
            },
            showActionInRoles: [SECRETARY, IRB],
            showInStatus: [CONFIRMED],
            disableConfirm: true,
        },
    ];

    let result = actions
        .filter((item) => {
            if (!item.condition) {
                return true;
            }

            return item?.condition?.();
        })
        .filter((item) => item?.showInStatus?.includes(statusId))
        .filter((item) => item?.showActionInRoles?.includes(userRole));

    return result;
};

export default usePostApprovalTableAction;
